import React from 'react';
import { MIcon } from '../Icon';
import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import { ISmartProps } from './types';
import { useStyletron } from '../../Themes';
import { mergeOverrides } from 'baseui';
import * as meta from '../../meta-data.json';
import { overridesInput } from './overridesInput';
import { overridesShared as calendarOverrides } from '../Calendar-base/overrides' //(props: any, dataProps: any, dataAria: any, propsRest: any)

const InputIcon = ({ size = 'small' }: { size?: string }) => {
	const [css]: any = useStyletron();

	const _iconSize =
		size == 'large' ? 'var(--epods--button-large-icon-size)' : 'var(--epods--button-default-icon-size)';
	return (
		<MIcon
			icon="calendar_today"
			size={_iconSize}
			color="var(--epods--color-text-primary)"
			className={css({
				marginRight: 'calc(00px - var(--epods--padding-right-iconBefore-input))',
				display: 'block',
				width: '1em',
				direction: 'rtl',
			})}
		/>
	);
};

export const overrides = (props: ISmartProps, dataProps: any, dataAria: any, propsRest: any, IOverrides: any) => {
	const InputOver = IOverrides
		? mergeOverrides(
			overridesInput(props as any, dataProps, dataAria, propsRest) as any,
			IOverrides?.props?.overrides as any,
		)
		: overridesInput(props as any, dataProps, dataAria, propsRest);

	return {
		Root: {
			props: {
				...{
					className: props.className,
					'data-epo': `epo-datepicker-${meta.version}`,
					part: `epo-datepicker-${meta.version}`,
					...getBaseCustomProps(props),
					...dataProps,
				},
				style: {
					borderRadius: '4px',
					borderTopWidth: '1px',
					borderRightWidth: '1px',
					borderBottomWidth: '1px',
					borderLeftWidth: '1px',
					borderTopStyle: 'solid',
					borderRightStyle: 'solid',
					borderBottomStyle: 'solid',
					borderLeftStyle: 'solid',
					borderTopColor: 'var(--epods--color-border)',
					borderRightColor: 'var(--epods--color-border)',
					borderBottomColor: 'var(--epods--color-border)',
					borderLeftColor: 'var(--epods--color-border)',
				},
			},
		},
		Input: {
			props: {
				id: props.id,
				...dataAria,
				...getFormCustomProps(props),
				placeholder: props.range
					? props.timeSelectStart
						? 'dd.mm.yyyy hh:mm - dd.mm.yyyy hh:mm'
						: 'dd.mm.yyyy - dd.mm.yyyy'
					: props.timeSelectStart
						? 'dd.mm.yyyy hh:mm'
						: 'dd.mm.yyyy',
				startEnhancer: <InputIcon size={props.size} />,
				clearOnEscape: true,
				overrides: { ...InputOver },
				...IOverrides?.props
			},
		},
		...calendarOverrides(props, dataProps, dataAria, propsRest)
	};
};
